import type { PlanDetailsCopy } from '../planDetails'

const hi: PlanDetailsCopy = {
  fieldLabels: {
    current_age: 'आपकी आयु',
    retirement_age: 'सेवानिवृत्ति कब',
    annual_income: 'वार्षिक आय',
    annual_savings: 'वार्षिक बचत',
    inflation: 'मुद्रास्फीति',
    realization_tax_rate: 'पूँजीगत लाभ कर की दर',
    cost_basis: 'लागत आधार',
    w0: 'आज की निवेश-योग्य परिसंपत्तियाँ',
    primary_residence: 'आपका घर',
    total_investable: 'निवेश-योग्य परिसंपत्तियाँ',
    expected_return: 'अपेक्षित प्रतिफल',
    volatility: 'अस्थिरता',
    horizon: 'योजना अवधि',
    jurisdiction: 'कर निवास',
    risk_aversion: 'जोखिम सहनशीलता',
    birth_year: 'जन्म वर्ष',
    birth_date: 'जन्म तिथि',
    marital_status: 'वैवाहिक स्थिति',
    dependents: 'आश्रित',
    dependent_ages: 'आश्रितों की आयु',
    children: 'बच्चे',
    children_birth_years: 'बच्चों के जन्म वर्ष',
    partner_age: 'जीवनसाथी की आयु',
    partner_annual_income: 'जीवनसाथी की वार्षिक आय',
    partner_retirement_age: 'जीवनसाथी की सेवानिवृत्ति आयु',
    plan_to_age: 'योजना किस आयु तक',
    gross_annual_income: 'सकल वार्षिक आय',
    net_income: 'शुद्ध आय',
    annual_spending: 'वार्षिक खर्च',
    essential_spending: 'आवश्यक खर्च',
    flexible_spending: 'लचीला खर्च',
    investments_total: 'कुल निवेश',
    total_investable_wealth: 'कुल निवेश-योग्य संपत्ति',
    portfolio_mix: 'पोर्टफोलियो आवंटन',
    cgt_rate: 'पूँजीगत आय पर कर दर',
    interest_rate: 'ब्याज दर',
    dividend_yield: 'लाभांश प्रतिफल',
    wealth_tax_rate: 'संपत्ति कर की दर',
    filing_jurisdictions: 'कर रिटर्न वाले देश',
    citizenship: 'नागरिकता',
    tax_residency: 'घोषित कर निवास',
    state: 'राज्य या प्रांत',
    region: 'क्षेत्र',
    city: 'शहर',
    locality: 'नगरपालिका',
    church_tax_applicable: 'चर्च कर लागू',
    life_cover: 'जीवन बीमा कवर',
    income_protection: 'आय सुरक्षा बीमा',
    employer_match: 'नियोक्ता का अंशदान',
    pension: 'पेंशन',
    state_pension: 'सरकारी पेंशन',
    social_security: 'सामाजिक सुरक्षा',
    wage_growth: 'वेतन वृद्धि',
    stability: 'आय की स्थिरता',
    has_will: 'वसीयत बनी है',
    risk_attitude: 'जोखिम के प्रति दृष्टिकोण',
  },
  keyLabels: {
    goal_priority: 'लक्ष्यों का क्रम',
    current_age: 'आयु',
    inflation: 'मुद्रास्फीति की धारणा',
    jurisdiction: 'कर निवास',
    realization_tax_rate: 'लक्ष्य के लिए बेचने पर कर',
    citizenship: 'नागरिकता',
    total_investable: 'निवेश-योग्य संपत्ति',
    annual_income: 'वार्षिक आय',
    annual_savings: 'वार्षिक बचत',
    risk_tier: 'जोखिम स्तर',
    retirement_age: 'सेवानिवृत्ति आयु',
    target_wealth: 'लक्षित संपत्ति',
    primary_residence_sellable: 'घर बेचना / छोटे घर में जाना',
  },
  channelLabels: {
    web_levers: 'वेबसाइट पर समायोजन',
    web_cockpit: 'निर्णय पैनल',
    web: 'वेबसाइट',
    chat: 'एआई सहायक',
    mcp: 'एआई सहायक',
    full_review: 'पूर्ण समीक्षा',
    full_plan: 'पूर्ण योजना',
    what_if: 'परिदृश्य विश्लेषण',
  },
  objectiveLabels: {
    status_quo: 'वर्तमान स्थिति',
    max_goal_probability: 'सफलता की अधिकतम संभावना',
    lowest_drawdown: 'न्यूनतम अधिकतम गिरावट',
    highest_growth: 'सर्वाधिक वृद्धि',
    fastest_to_goal: 'लक्ष्य सबसे जल्दी',
  },
  choices: {
    interest_only: 'केवल ब्याज',
    fixed_rate_amortizing: 'किस्तों में मूलधन चुकौती (स्थिर दर)',
    variable_rate_amortizing: 'किस्तों में मूलधन चुकौती (परिवर्तनीय दर)',
    repayment: 'किस्तों में मूलधन चुकौती',
    refinance: 'बाज़ार दर पर पुनर्वित्त',
    repay: 'पूरा चुकाना',
  },
  values: {
    yearsShort: (n) => `${n} वर्ष`,
    shareAbout: (pct) => `इसके मूल्य का लगभग ${pct}`,
    sharePart: 'इसके मूल्य का एक हिस्सा',
    aroundAge: (age) => ` लगभग ${age} वर्ष की आयु में`,
    inAboutYears: (n) => ` लगभग ${n} वर्ष में`,
    maySellFor: (share, when) => `${share}${when} जुटाने के लिए बेचा जा सकता है, केवल तभी जब इससे योजना बेहतर हो।`,
    maySell: 'बेचा जा सकता है, यदि इससे योजना बेहतर हो।',
    structuredFact: 'संरचित जानकारी',
  },
  ask: { talkThrough: 'MyCIO से इस पर बात करें' },
  review: {
    openInputCheckFailed: 'अधूरी जानकारी की जाँच पूरी नहीं हो सकी। नीचे समीक्षा की स्थिति देखें।',
    finishedLoading: 'आपकी समीक्षा पूरी हो गई है। परिणाम लोड हो रहे हैं…',
    draftReady: 'आपकी प्रारंभिक समीक्षा तैयार है — पूरा हुआ विश्लेषण, जो गणना नहीं हो सकी, और उसे पूरा करने वाले प्रश्न नीचे हैं।',
    finishedNotLoaded: 'आपकी समीक्षा पूरी हो गई है, लेकिन परिणाम अभी लोड नहीं हो सके। फिर से कोशिश की जा रही है — गणना दोबारा नहीं चलेगी।',
    fetchFailed: 'आपकी समीक्षा पूरी हो गई है, लेकिन अभी इसे प्राप्त नहीं किया जा सका। यह सहेजी हुई है — थोड़ी देर में फिर कोशिश करें; दोबारा गणना की ज़रूरत नहीं है।',
    notComputed: (list) => `इस बार गणना नहीं हुई: ${list}।`,
    changesNotSaved: (n, f) => `${n === 1 ? '1 बदलाव सहेजा नहीं गया' : `${f} बदलाव सहेजे नहीं गए`} — «आपकी जानकारी» देखें।`,
  },
  facts: {
    chooseOption: 'एक विकल्प चुनें।',
    couldNotSave: 'यह मान सहेजा नहीं जा सका। आपकी योजना में कोई बदलाव नहीं हुआ।',
    couldNotUndo: 'यह बदलाव वापस नहीं लिया जा सका।',
    choosePlaceholder: 'चुनें…',
    confirmedBadge: 'पुष्ट — बदलने के लिए चैट में कहें',
    confirmedTitle: (was) => `आपने पहले इसे ${was} के रूप में पुष्ट किया था। इसे बदलने के लिए चैट में MyCIO से कहें।`,
  },
  assumptionsToConfirm: { anInput: 'कोई इनपुट', assumedSuffix: (v) => ` — मानी गई राशि: ${v}` },
  editor: {
    enterNumber: 'कोई संख्या दर्ज करें।',
    enterNumberFor: (l) => `«${l}» के लिए संख्या दर्ज करें।`,
    enterPercentFor: (l) => `«${l}» के लिए प्रतिशत दर्ज करें।`,
    chooseYesNoFor: (l) => `«${l}» के लिए हाँ या नहीं चुनें।`,
    semicolonBetween: (l) => `«${l}» की प्रविष्टियों के बीच ";" लगाएँ।`,
    useNumbersFor: (l) => `«${l}» के लिए संख्याएँ इस्तेमाल करें।`,
    wholeNumbersFor: (l) => `«${l}» के लिए पूर्ण संख्याएँ इस्तेमाल करें और उनके बीच ";" लगाएँ।`,
    commaSeparated: 'अल्पविराम से अलग',
  },
  freshnessUnknown: 'हम पुष्टि नहीं कर सके कि आपकी सहेजी गई गणना में खातों के नवीनतम बदलाव शामिल हैं या नहीं। इन आँकड़ों पर भरोसा करने से पहले पेज रीफ़्रेश करें और अपने खाते जाँचें।',
  goals: { goalN: (n) => `लक्ष्य ${n}`, whatMoves: 'इसे क्या प्रभावित करता है →', earliest: (y) => `सबसे जल्दी ≈ ${y}`, rank: 'क्रम' },
  issues: {
    mainConstraint: 'इस योजना की मुख्य बाधा',
    riskToReview: 'समीक्षा योग्य जोखिम',
    missingInformation: 'अधूरी जानकारी',
    whyItMatters: (t) => `यह क्यों मायने रखता है: ${t}`,
    seeEvidence: 'समर्थक साक्ष्य देखें ↓',
    noneFound: 'इस योजना में अभी मौजूद जानकारी के आधार पर पूरे हुए विश्लेषण में कोई महत्वपूर्ण मुद्दा नहीं मिला।',
    notAvailable: 'मुद्दों का विश्लेषण अभी उपलब्ध नहीं है। इस खाली भाग को यह न समझें कि कोई मुद्दा नहीं है।',
    discussQuestion: 'इस योजना में मिले मुद्दों की समीक्षा करें। उनके साक्ष्य समझाएँ और मुझसे पूछें कि क्या मेरी परिस्थितियों की कोई अधूरी जानकारी उनकी प्राथमिकता या निष्कर्ष बदल सकती है।',
    discussLabel: 'इन मुद्दों पर चर्चा करें',
  },
  policies: {
    optionTested: 'परखा गया विकल्प',
    computedEffect: (v) => `गणना किया गया प्रभाव: ${v}`,
    tradeoff: (v) => `समझौता: ${v}`,
    backToAction: 'कार्रवाई पर लौटें ↑',
    tradeoffsHeading: 'परखे गए मामलों के समझौते',
  },
  transfer: {
    toHeirs: (m) => `उत्तराधिकारियों को +${m}`,
    fundedPoints: (label, pts) => `${label} ${pts} प्रतिशत अंक`,
    noChange: ' · आपके लक्ष्यों की फ़ंडिंग पर कोई असर नहीं',
  },
  tax: {
    rulesIntro: 'केवल वही नियम दिखाए गए हैं जो इस गणना से जुड़े हैं। हर प्रविष्टि में दर्ज स्रोत का विवरण है; जो तिथियाँ या दायरे की जानकारी नहीं है, वह स्पष्ट रूप से अनुपलब्ध दिखाई गई है।',
    title: 'इस योजना में लागू कर व्यवहार',
    countryBookPrimary: 'अनुमान में संबंधित देश के कर नियम साल-दर-साल लागू किए गए। जिन स्रोतों को स्पष्ट रूप से आधिकारिक या प्राथमिक दर्ज किया गया है, वे नीचे दिए गए हैं।',
    countryBookNoPrimary: 'अनुमान में संबंधित देश के कर नियम साल-दर-साल लागू किए गए। इस सहेजे गए परिणाम के साथ अभी प्राथमिक स्रोतों के लिंक नहीं जुड़े हैं, इसलिए कर से जुड़े निर्णय लेने से पहले उनकी पुष्टि करें।',
    simplified: 'इस गणना में सरल कर व्यवहार का उपयोग हुआ है। कर से जुड़ी तुलनाओं पर भरोसा करने से पहले नीचे दी गई सीमाएँ देखें।',
    askQuestion: 'समझाएँ कि इस योजना पर कौन-से कर कानून और देश-स्तरीय नियम लागू हुए, किन्हें अनुमानित किया गया या छोड़ा गया, और मेरी कर स्थिति के कौन-से तथ्य परिणाम बदल सकते हैं। केवल वही प्राथमिक स्रोत इस्तेमाल करें जो वास्तव में इस गणना से जुड़े हैं, और जो स्रोत नहीं हैं उनका नाम बताएँ।',
    askLabel: 'कर व्यवहार के बारे में पूछें',
  },
  inputs: { title: 'परिणाम बदल सकने वाले इनपुट', infoToConfirm: 'पुष्टि के लिए जानकारी' },
  gated: {
    countChoices: (_n, f) => `आपके लिए परखे गए ${f} विकल्प`,
    mappedYears: (_n, f) => `हमने अगले ${f} वर्षों का अनुमान लगाया`,
    extraChecks: (_n, f) => `आपकी योजना को ${f} अतिरिक्त तरीकों से जाँचा गया`,
    placeholderRows: ['उदाहरण पंक्ति', 'नमूना आँकड़ा', 'उदाहरण विकल्प', 'प्लेसहोल्डर'],
  },
}

export default hi
